import React from 'react';

import StyledProcessingBar from './Styled';

const ProcessingBar = (props) => (
  <StyledProcessingBar bg='primary' {...props} />
);

export default ProcessingBar;
